import li1 from "../../assets/images/li1.jpg"
import liIcon from "../../assets/images/li-icon.svg"
import maleSVG from "../../assets/images/male.svg"
import millify from "millify"
import moment from "moment"

export const LatestIdeaCard = ({ empName, createdAt, upvotes, desc }) => {
    // return (
    //     <>
    //         <div className="col-6 col-lg-3 mb-1">
    //             <div className="card li mb-0" style={{ background: `url(${li1})` }}>
    //                 <div className="card-body p-1">
    //                     <div className="media mt-4">
    //                         <div className="avatar mr-5">
    //                             <img src={maleSVG} className="rounded" width="24" height="24" alt="img" />
    //                         </div>
    //                         <div className="media-body my-auto">
    //                             <p className="mb-0 font-lato font-10 font-weight-600 line-height-15 text-white">
    //                                 {empName}</p>
    //                             <p className="mb-0 font-lato font-8 opacity-50 line-height-10 text-white">
    //                                 {moment(createdAt).fromNow()}</p>
    //                         </div>
    //                     </div>
    //                 </div>
    //             </div>
    //             <div className="lif font-lato font-10 font-weight-600"><img src={liIcon} alt="img" className="mr-5" />{millify(upvotes)} Upvotes</div>
    //         </div>
    //     </>
    // )

    return (
        <div className="col-12 col-lg-3">
            <div className="card">
                <div className="card-body h-200p">
                    <div className="media">
                        <div className="starshot-ring mr-1">
                            <div className="avatar">
                                <div className="text-icon font-lato">{empName[0]}</div>
                            </div>
                        </div>
                        <div className="media-body my-auto">
                            <p className="mb-0 font-lato">{empName}</p>
                            <p className="mb-0 font-lato font-10 star-orange">{moment(createdAt).fromNow()}</p>
                        </div>
                    </div>
                    <div className="mt-1">
                        <p className="text-starshot font-lato">{millify(upvotes)} upvotes</p>
                    </div>
                    <p className="overflow-auto h-80p">
                        {desc}
                    </p>
                </div>
            </div>
        </div>
    )
}